module.exports = __webpack_public_path__ + "static/media/logo-light.f15cdf24.png";